import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCommentLight = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 17,
	height: 16,
	viewBox: "0 0 17 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M14.5001 7.66667C14.5001 10.7963 11.963 13.3333 8.83341 13.3333C8.11556 13.3333 7.42888 13.1999 6.79685 12.9564C6.68129 12.9118 6.62351 12.8896 6.57756 12.879C6.53237 12.8686 6.49966 12.8642 6.45332 12.8624C6.4062 12.8606 6.35451 12.866 6.25112 12.8767L2.8371 13.2296C2.51161 13.2632 2.34886 13.2801 2.25286 13.2215C2.16924 13.1705 2.11229 13.0853 2.09713 12.9885C2.07972 12.8774 2.15749 12.7335 2.31303 12.4456L3.40347 10.4272C3.49327 10.261 3.53817 10.1779 3.55851 10.098C3.5786 10.019 3.58345 9.96213 3.57703 9.88095C3.57052 9.79875 3.53446 9.69175 3.46232 9.47774C3.27064 8.90906 3.16674 8.3 3.16674 7.66667C3.16674 4.53705 5.7038 2 8.83341 2C11.963 2 14.5001 4.53705 14.5001 7.66667Z",
		stroke: "#808080",
		strokeWidth: 1.33333,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgCommentLight;
